module.exports = __webpack_public_path__ + "img/collection-weddingRingsModern.dceb9cc.webp";